import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { img_collapse, img_expand } from '../../../utils/ImagesManagementUtils';

//= ========================================================================

const ExpandedText = ({
  children,
  isExpanded,
  onPress,
}) => {
  const myStyles = {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 10,
    },
    image: {
      width: 16,
      height: 16,
      marginTop: 4,
    },
  };

  return (
    <TouchableOpacity
      style={myStyles.container}
      activeOpacity={1}
      onPress={onPress}
    >
      {children}
      <Image
        fadeDuration={0}
        style={myStyles.image}
        source={isExpanded ? img_collapse : img_expand}
      />
    </TouchableOpacity>
  );
};
export default ExpandedText;
